module.exports = __webpack_public_path__ + "static/media/logotipo-artefield.37a72c2a.png";